// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-view-view{width:max-content;min-width:var(--app-content-width, 100%)}`, "",{"version":3,"sources":["webpack://./src/pages/View.vue"],"names":[],"mappings":"AACA,gBACC,iBAAA,CACA,wCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
